import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 3h-2a6 6 0 0 0 -6 6h-3v4h3v8h4v-7h4v7h4v-11h-8v-1.033a1.967 1.967 0 0 1 2 -1.967h2v-4","key":"svg-0"}]]

/**
 * IconBrandFiverr
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtZml2ZXJyIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNSAzaC0yYTYgNiAwIDAgMCAtNiA2aC0zdjRoM3Y4aDR2LTdoNHY3aDR2LTExaC04di0xLjAzM2ExLjk2NyAxLjk2NyAwIDAgMSAyIC0xLjk2N2gydi00IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-fiverr
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandFiverr = createReactComponent('outline', 'brand-fiverr', 'BrandFiverr', __iconNode);

export default IconBrandFiverr;